import { AppUpdate } from '@/types/updates';

export const update_2026_04: AppUpdate = {
  id: 'audio-synthesis-2026-04',
  slug: 'advanced-audio-synthesis-engine-update',
  title: 'Sonic Precision: The Audio Synthesis Revolution',
  description: 'In early May, we shifted our focus to the soul of the simulation: the sound. We introduced a completely overhauled audio synthesis engine and precision MIDI filtering.',
  date: 'May 2, 2026',
  timestamp: 1777852800,
  category: 'IMPROVEMENT',
  version: '0.9.8',
  readTime: '5 min read',
  author: {
    name: 'FCG Dev',
    role: 'Lead Architect'
  },
  content: [
    {
      type: 'heading',
      content: 'Painting with Frequencies'
    },
    {
      type: 'text',
      content: 'One of the most requested features was more control over how the simulation sounds. Previously, our audio was tied to simple triggers. In early May, we introduced the Rhythmic MIDI Filter Section, allowing you to isolate specific notes and frequencies to create truly musical physics art.'
    },
    {
      type: 'heading',
      content: 'The Pitch Histogram'
    },
    {
      type: 'text',
      content: 'To help creators understand their music better, we built the Pitch Histogram—a real-time visual representation of every MIDI note entering the system. This allows you to see exactly which octaves are most active and assign visual color shifts or physics events to specific "musical hotspots."'
    },
    {
      type: 'list',
      content: [
        'Note-Specific Triggers: Assign different "Blasts" or color changes to specific notes (e.g., C4 triggers a green ripple, G4 triggers an explosion).',
        'Octave Filtering: Limit the simulation to only react to bass notes, mid-range melodies, or high-end percussion.',
        'Enhanced Synth Rack: New oscillator types including Sawtooth, FM, and Pulse waves for richer sound design.',
        'Audio Post-Processing: Dedicated controls for Reverb, Delay, and Bitcrush now available in the Audio Studio tab.'
      ]
    },
    {
      type: 'heading',
      content: 'Zero-Latency Audio Sync'
    },
    {
      type: 'text',
      content: 'We optimized our Tone.js integration to ensure that the moment a ball hits a wall, the sound is synthesized instantly. There is no longer a delay between the visual impact and the auditory response, creating a "locked-in" feeling that is essential for satisfaction-style videos.'
    },
    {
      type: 'highlight',
      content: '"Music isn\'t just background noise in Fun Circle Games; it is the conductor. Our new filtering tools allow you to treat every physics event like a note in a grand visual symphony."'
    },
    {
      type: 'heading',
      content: 'Audio Studio: The Pro Rack'
    },
    {
      type: 'text',
      content: 'We also introduced the "Manual Rack" in the Audio Studio. This is a modular-style interface where you can drag and connect different audio effects and modifiers. Whether you want a clean crystalline chime or a heavy industrial distortion, you now have the tools to build it from scratch.'
    }
  ]
};
